import { ROUTES } from "./routes";

/** Preserve internal return locations, without accepting external or auth-loop targets. */
export function getPostLoginDestination(state: unknown, defaultRoute: string): string {
  if (defaultRoute === ROUTES.PORTAL_UNAVAILABLE) return defaultRoute;
  if (!state || typeof state !== "object" || !("from" in state)) return defaultRoute;
  const from = state.from;
  if (!from || typeof from !== "object" || !("pathname" in from)) return defaultRoute;
  const path = from.pathname;
  if (
    typeof path !== "string" ||
    !path.startsWith("/") ||
    path.startsWith("//") ||
    path.includes("\\") ||
    (path.startsWith("/auth/") && path !== ROUTES.AUTH.VERIFY_EMAIL)
  )
    return defaultRoute;
  const search =
    "search" in from && typeof from.search === "string" && from.search.startsWith("?")
      ? from.search
      : "";
  const hash =
    "hash" in from && typeof from.hash === "string" && from.hash.startsWith("#") ? from.hash : "";
  return `${path}${search}${hash}`;
}
